import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
  })


export class LoggerService {
constructor(private http: HttpClient){}

    public getList(request) {
               return this.http.post<any>("/UserDashboard/GetNewAndReturningUsers", request);
      }

        public GetAllLogger(request) {
               return this.http.post<any>("/EcommerceLog/GetAllLogs", request);
      }

            public GetVersionsByLoggerId(id) {
               return this.http.get<any>("/EcommerceLog/GetLogWithVersions/"+id );
      }




            public AddLogVersion(payload) {
               return this.http.post<any>("/EcommerceLog/AddLogVersion",payload );
      }

              public ReSubmitLog(logId,payload?:any) {
               return this.http.post<any>("/EcommerceLog/ReSubmitLog?logId="+logId,{} );
      }

              public SetMainVersion(logId,versionId) {
               return this.http.post<any>("/EcommerceLog/SetMainVersion?"+"logId="+logId+"&versionId="+versionId,{} );
      }

  }
